import "./ChecklistCard.css";
import { useAppSelector } from "Components/Hooks/hooks";
import Icon from "Components/Icons/Icon";
import { TourKey } from "tour/tourKeys";

const steps: {
  id: number;
  key: TourKey[];
  title: string;
  descriptionPoints: string[];
}[] = [
  {
    id: 1,
    key: ["dashboard"],
    title: "Explore Your Dashboard",
    descriptionPoints: [
      "View quotes, invoices, and totals",
      "See recent activity",
      "Use quick actions (New Quote, New Invoice)",
    ],
  },
  {
    id: 2,
    key: ["quoteSummary", "quoteItems", "quoteSections"],
    title: "Create Your First Quote",
    descriptionPoints: [
      "Start a new quote",
      "Add or create a customer",
      "Add job details",
      "Add items or services",
      "Review pricing & totals",
      "Preview & send quote",
    ],
  },
  {
    id: 3,
    key: ["invoiceItems", "invoiceSummary"],
    title: "Send Your First Invoice",
    descriptionPoints: [
      "Convert quote to invoice",
      "Send invoice to customer",
      "Track payment status",
    ],
  },
  {
    id: 4,
    key: ["presetQuote"],
    title: "Save Time with Templates",
    descriptionPoints: [
      "View preset quote templates",
      "Use a template",
      "Save a quote as a template",
    ],
  },
  {
    id: 5,
    key: ["settings"],
    title: "Personalise Your Account",
    descriptionPoints: ["Explore settings"],
  },
];

export default function ChecklistCard({
  onCardPress,
}: {
  onCardPress: (id: number) => void;
}) {
  const userName = useAppSelector((s) => s.auth.user?.name);
  const allTours = useAppSelector((s) => s.tours);

  const completedFlows = [
    // 1. Dashboard
    allTours.dashboard.isDBfinished,

    // 2. Quote flow (all must be finished)
    allTours.quoteSummary.isDBfinished &&
      allTours.quoteItems.isDBfinished &&
      allTours.quoteSections.isDBfinished,

    // 3. Preset Quote
    allTours.presetQuote.isDBfinished,

    // 4. Invoice flow (all must be finished)
    allTours.invoiceItems.isDBfinished && allTours.invoiceSummary.isDBfinished,

    // 5. Settings
    allTours.settings.isDBfinished,
  ];

  const completed = completedFlows.filter(Boolean).length;

  const percent = Math.round((completed / steps.length) * 100);

  const stepsWithStatus = steps.map((step) => ({
    ...step,
    done: step.key.every((k) => allTours[k]?.isDBfinished),
  }));

  return (
    <div className="card">
      {/* Header */}
      <div className="header">
        <h3>Hello, {userName}! 👋</h3>

        <div className="progressWrapper">
          <div className="progressBar">
            <div style={{ width: `${percent}%` }} className="progressFill" />
          </div>
          <span className="progressText">{percent}% completed</span>
        </div>
      </div>

      {/* Steps */}
      <div className="steps">
        {stepsWithStatus.map((step) => (
          <div
            key={step.id}
            className={`step ${step.done ? "stepDone" : ""}`}
            onClick={() => onCardPress(step.id)}
          >
            <div className="stepLeft">
              <span className="stepNumber">{step.id}.</span>
              <div className="content">
                <p className={`title`}>{step.title}</p>
                {!step.done && (
                  <ul className="desc">
                    {step.descriptionPoints.map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                  </ul>
                )}
              </div>
              {step.done ? (
                // <span className="checkbox checked">✔</span>
                <Icon name="CheckBox" className="checkbox" />
              ) : (
                // <span className="checkbox" />`
                <Icon name="RightArrow" fontSize={20} className="arrow" />
              )}
            </div>

            {/* {!step.done && <span className="arrow">›</span>} */}
          </div>
        ))}
      </div>
    </div>
  );
}
